( function( $, window, document, undefined ) {

	var $hero = $('.hero');
	var $nav_wrap = $('.nav-wrap');
	var $header = $('.site-header');
	var $sticky_menu = $('.sticky-menu');
	var $body = $('body');
	var $cta = $('#cta');
	var $footer = $('.site-footer');

	$(window).on('scroll load', throttle( function() {

		if ( !check_elem_visibility($hero) && !$nav_wrap.hasClass('is-sticky') ) {

			$nav_wrap.addClass('animate-in is-sticky');
			$sticky_menu.addClass('is-visible');

			setTimeout( function() {
				$nav_wrap.removeClass('animate-in');
			}, 150);

		} else if ( check_elem_visibility($hero) && $nav_wrap.hasClass('is-sticky') ) {

			$nav_wrap.addClass('animate-out');
			$sticky_menu.removeClass('is-visible');

			setTimeout( function() {
				$nav_wrap.removeClass('animate-out is-sticky');
			}, 150);

		}

		if ( check_elem_visibility($footer) && window.matchMedia('(max-width: 767px)').matches ) {
			$cta.addClass('hide');
		} else {
			$cta.removeClass('hide');
		}

		var $availability = $('.nav-availability');
		var $cafe = $('.nav-cafe');
		var $studio = $('.nav-studio');
		var $location = $('.nav-location');
		var $social = $('.nav-social');
		var $contact = $('.nav-contact');

		if ( check_elem_visibility( $contact ) ) 
		{
			sticky_menu_active( 'contact' );
		} 
		else if ( check_elem_visibility( $social ) )
		{
			sticky_menu_active( 'social' );
		}
		else if ( check_elem_visibility( $location ) )
		{
			sticky_menu_active( 'location' );
		}
		else if( check_elem_visibility( $studio ) )
		{
			sticky_menu_active( 'studio' );
		}
		else if( check_elem_visibility( $cafe ) )
		{
			sticky_menu_active( 'cafe' );
		}
		else if( check_elem_visibility( $availability ) )
		{
			sticky_menu_active( 'availability' );
		}
		else
		{
			$sticky_menu.find('a').each( function() {
				$(this).removeClass('is-active');
			});
		}

		var $headlineA = $('.headline__availability');

		if ( check_elem_full_visibility( $headlineA ) ) {

			var drips = $headlineA.find('.drip');

			drips.each( function() {
				$(this).addClass('animate');
			});
		}

	}, 100 ));

	function check_elem_visibility(elem) {
		if ( !elem || !elem.length ) {
			return false;
		}

		var topOfElement = elem.offset().top;
	    var bottomOfElement = elem.offset().top + elem.outerHeight();
	    var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
	    var topOfScreen = $(window).scrollTop();

	    if ((bottomOfScreen > topOfElement) && (topOfScreen < bottomOfElement)) {
	        return true;
	    } else {
	        return false;
	    }
	}

	function check_elem_full_visibility(elem) {
		if ( !elem || !elem.length ) {
			return false;
		}
		
		var topOfElement = elem.offset().top;
	    var bottomOfElement = elem.offset().top + elem.outerHeight();
	    var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
	    var topOfScreen = $(window).scrollTop();

	    if ((bottomOfScreen > bottomOfElement) && (topOfScreen < bottomOfElement)) {
	        return true;
	    } else {
	        return false;
	    }
	}

	function sticky_menu_active(className) {

		var ele_class = '.' + className;
		var ele = $sticky_menu.find(ele_class);

		if ( !ele.hasClass('is-active') ) {

			$sticky_menu.find('a').each( function() {
				$(this).removeClass('is-active');
			});

			ele.addClass('is-active');

		}
	}
	
} )( jQuery, window, document );
